import { Controller } from "@hotwired/stimulus";

// Warn users about unsaved changes when navigating away
export default class extends Controller {
  static values = { message: String };

  connect() {
    this.dirty = false;

    this.onInput = this.onInput.bind(this);
    this.onBeforeVisit = this.onBeforeVisit.bind(this);
    this.onBeforeUnload = this.onBeforeUnload.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // Track changes within the controller element
    this.element.addEventListener("input", this.onInput, true);
    this.element.addEventListener("change", this.onInput, true);
    this.element.addEventListener("submit", this.onSubmit, true);

    // Intercept Turbo navigation and browser tab/window close
    document.addEventListener("turbo:before-visit", this.onBeforeVisit);
    window.addEventListener("beforeunload", this.onBeforeUnload);
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput, true);
    this.element.removeEventListener("change", this.onInput, true);
    this.element.removeEventListener("submit", this.onSubmit, true);
    document.removeEventListener("turbo:before-visit", this.onBeforeVisit);
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  }

  onInput(event) {
    const target = event.target;
    if (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)) {
      if (["submit", "button", "reset", "hidden"].includes(target.type)) return;
      this.dirty = true;
    }
  }

  onSubmit(_event) {
    // Allow navigation without prompt after submit within scope
    this.dirty = false;
  }

  onBeforeVisit(event) {
    if (!this.dirty) return;
    if (!window.confirm(this.message)) {
      event.preventDefault();
    } else {
      this.dirty = false;
    }
  }

  onBeforeUnload(event) {
    if (!this.dirty) return;
    event.preventDefault();
    event.returnValue = this.message;
    return this.message;
  }

  get message() {
    return this.hasMessageValue
      ? this.messageValue
      : "You have unsaved changes. Are you sure you want to leave this page?";
  }
}
